import * as React from 'react';
import { UserState } from 'app/reducers/state';
import { Dialog, Callout, Intent } from '@blueprintjs/core';
import { LargeButton } from '../LargeButton';
import { StandardInput } from '../StandardInput';
import { translateKey } from 'app/utils/forms';

interface Props {
    user: UserState;
    isOpen: boolean;
    callback: (newPassword: string) => void;
    onClose: () => void;
};

interface State {
    errorMessage: string;
    userPassword: string;
    userPasswordVerify: string;
}

export class NewPasswordDialog extends React.Component<Props, State> {

    state: State = {
        errorMessage: "",
        userPassword: "",
        userPasswordVerify: ""
    }

    handleChangePassword = () => {
        const {
            userPassword,
            userPasswordVerify
        } = this.state;

        if (userPassword === "") {
            this.setState({
                errorMessage: translateKey('vleader.newPassword')
            });

            return;
        }

        if (userPassword !== userPasswordVerify) {
            this.setState({
                errorMessage: translateKey('vleader.passwordMatch')
            });

            return;
        }

        this.props.callback(userPassword);
        this.props.onClose();
    }

    handlePasswordChange = (e:any) => {
		if (e && e.target) {
			const newValue = e.target.value;

			this.setState({
				userPassword: newValue
			});
		}
    }
    
    handlePasswordVerifyChange = (e:any) => {
		if (e && e.target) {
			const newValue = e.target.value;

			this.setState({
				userPasswordVerify: newValue
			});
		}
	}

	render() {
        const {
            errorMessage,
            userPasswordVerify,
            userPassword
        } = this.state;

        const errorMessageVisible = !(errorMessage === "");

        const {
            isOpen,
            onClose
        } = this.props;

        return <Dialog
            icon="info-sign"
            onClose={onClose}
            isOpen={isOpen}
            title={translateKey('vleader.passwordChange')}
        >
            <span style={{display: 'block', margin: '20px'}}>
                {errorMessageVisible ? <Callout style={{marginBottom: '20px'}} intent={Intent.DANGER}>{errorMessage}</Callout> : undefined}

                <StandardInput 
                    autoFocus={true}
                    onChange={this.handlePasswordChange}
                    type={"password"}
                    value={userPassword}
                    label={translateKey('login.password')} />
                <StandardInput 
                    autoFocus={false}
                    onChange={this.handlePasswordVerifyChange}
                    type={"password"}
                    value={userPasswordVerify}
                    label={translateKey('login.passwordAgain')} />

                <LargeButton text={translateKey('vleader.save')} rightIcon={"password"} intent={Intent.SUCCESS} onClick={() => {
                    this.handleChangePassword();
                }} />
            </span>
        </Dialog>
	}
}
